import { Text, Image } from "@chakra-ui/react";
import { APPLY_STATUS_MAPS } from "../constants";
import { BXButton } from "@/styles";

const AddBtn = ({ title, onClick, status }) => {
  return (
    <BXButton
      h="44px"
      fontSize="12px"
      minWidth={"140px"}
      borderRadius={"30px"}
      className={
        status === APPLY_STATUS_MAPS.PENDING ||
        status === APPLY_STATUS_MAPS.DENIED
          ? "disabled"
          : ""
      }
      onClick={() => {
        if (
          status !== APPLY_STATUS_MAPS.PENDING &&
          status !== APPLY_STATUS_MAPS.DENIED
        ) {
          onClick && onClick();
        }
      }}
    >
      <Image
        boxSize="12px"
        src="../wwwsite/images/add.svg"
        cursor={"pointer"}
        mr={"10px"}
      />
      <Text color={"#fff"} fontSize={"14px"}>
        {title}
      </Text>
    </BXButton>
  );
};

export default AddBtn;
